import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const endPoint = `${baseUrl}/apikey`;

const getAllApiKeys = () => {
    return http.get(endPoint);
};

const getApiKeysById = (id) => {
    return http.get(`${endPoint}/${id}`);
};

const getApiKeysBySharedKey = (sharedKey) => {
    return http.get(`${endPoint}/shared/${sharedKey}`);
};

const getGeneratedKey = () => {
    return http.get(`${endPoint}/keygen`);
};

const saveApiKey = (apiKey) => {
    if (!apiKey.apiKeyId) {
        return http.post(`${endPoint}`, apiKey);
    } else {
        const body = { ...apiKey };
        delete body.apiKeyId;
        return http.put(`${endPoint}/${apiKey.apiKeyId}`, body);
    }
};

const deleteApiKey = (apiKeyId) => {
    return http.delete(`${endPoint}/${apiKeyId}`);
};

export { getAllApiKeys, getApiKeysById, getApiKeysBySharedKey, getGeneratedKey, saveApiKey, deleteApiKey };
